import ButtonProps from '../../interfaces/ButtonProps'
import StyledButton from '../../styles/shared/Button'

export default function Button(props: ButtonProps) {
	const StyledBtn = StyledButton(props)

	let valueFill: 'default' | 'clear' | 'outline' | 'solid' | undefined
	if (
		props.fill == 'default' ||
		props.fill == 'clear' ||
		props.fill == 'outline' ||
		props.fill == 'solid' ||
		props.fill == undefined
	)
		valueFill = props.fill

	return (
		<StyledBtn fill={valueFill} onClick={props.onClick}>
			{props.children}
		</StyledBtn>
	)
}
